export default __webpack_public_path__ + "static/media/base2.bc0f8b36.jpg";